export class cameraControlPotreeFunc {
    static setControls(inControl: string) {
        let viewer = window.potreeViewer
        switch (inControl) {
            case 'Orbit':
                window.potreeViewer.setControls(viewer.orbitControls);
                break;
            case 'Fly':
                viewer.setControls(viewer.fpControls);
                viewer.fpControls.lockElevation = false;
                break;
            case 'Helicopter':
                viewer.setControls(viewer.fpControls);
                viewer.fpControls.lockElevation = true;
                break;
            case 'Earth':
                window.potreeViewer.setControls(viewer.earthControls);
                break;
        }
    }
    static fullExtent() {
        window.potreeViewer.fitToScreen();
    }
    static toggleNavigationCube() {
        window.potreeViewer.toggleNavigationCube();
    }
    static toggleCompass() {
        const visible = !window.potreeViewer.compass.isVisible();
        window.potreeViewer.compass.setVisible(visible);
    }
}